<template>
  <v-dialog
    v-model="internalDialog"
    max-width="600"
    persistent
  >
    <v-card>
      <v-card-actions class="justify-end">
        <v-icon
          text
          @click="handleClose"
        >
          mdi-close-thick
        </v-icon>
      </v-card-actions>
      <v-toolbar
        dark
        style="background-color:rgb(204 33 40);color:white !important"
      >
        ENVÍO DE CORREO DE FACTURA [ {{ invoiceItem.prefix }} - {{ invoiceItem.consecutive }} ]
      </v-toolbar>

      <v-card-text class="pt-4">
        <v-combobox
          v-if="!progress && msgResponseEmail === ''"
          v-model="emailsAdicionales"
          chips
          clearable
          deletable-chips
          hint="Escriba un correo y presione Enter para agregar"
          label="Correos adicionales (opcional)"
          multiple
          persistent-hint
          small-chips
        >
          <template v-slot:selection="{ item, index }">
            <v-chip
              close
              small
              @click:close="emailsAdicionales.splice(index, 1)"
            >
              {{ item }}
            </v-chip>
          </template>
        </v-combobox>
        <div
          v-if="!isEmailsValid"
          class="red--text text-caption mt-1"
        >
          Uno o más correos no tienen un formato válido
        </div>

        <v-row
          v-if="progress"
          align-content="center"
          class="fill-height"
          justify="center"
        >
          <v-col cols="6">
            <v-col
              class="text-subtitle-1 text-center"
              cols="12"
            >
              Enviando Correo
            </v-col>
            <v-progress-linear
              color="red darken-4"
              height="6"
              indeterminate
              rounded
            />
          </v-col>
        </v-row>

        <!-- Mensaje simple para usuarios no administradores -->
        <v-alert
          v-if="msgResponseEmail !== '' && !isAdmin"
          :type="msgResponseEmail.Error ? 'error' : 'success'"
          text
        >
          {{ emailAlertMessage }}
        </v-alert>

        <!-- JSON detallado para usuarios administradores -->
        <json-viewer
          v-if="msgResponseEmail !== '' && isAdmin"
          :value="msgResponseEmail"
          copyable="true"
        >
          <template
            v-if="!progress"
            v-slot:copy
          >
            Copiar
            <v-icon
              class="mr-2"
              color="info darken-3"
              style="cursor: pointer"
            >
              mdi-content-copy
            </v-icon>
          </template>
        </json-viewer>
      </v-card-text>

      <v-card-actions class="justify-end">
        <v-btn
          text
          @click="handleClose"
        >
          Cerrar
        </v-btn>
        <v-btn
          v-if="!progress && msgResponseEmail === ''"
          style="background-color:rgb(204 33 40);color:white !important"
          :disabled="!isEmailsValid"
          @click="sendEmail"
        >
          <v-icon left>
            mdi-send
          </v-icon>
          Enviar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'SendEmailModal',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    invoiceItem: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
      emailsAdicionales: [],
      progress: false,
      msgResponseEmail: '',
    }
  },
  computed: {
    ...mapState('invoice', ['responseEmail']),
    internalDialog: {
      get () {
        return this.visible
      },
      set (value) {
        if (!value) {
          this.$emit('close')
        }
      },
    },
    isEmailsValid () {
      if (this.emailsAdicionales.length === 0) return true
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      return this.emailsAdicionales.every(email => emailRegex.test(email))
    },
    isAdmin () {
      const roles = JSON.parse(localStorage.getItem('role') || '[]')
      return roles.includes('Administrador')
    },
    emailAlertMessage () {
      if (this.msgResponseEmail === '') return ''
      if (this.msgResponseEmail.Error) {
        return this.msgResponseEmail.Mensaje || 'No se pudo reenviar la notificación del documento'
      }
      return 'La notificación del documento se ha reenviado exitosamente'
    },
  },
  watch: {
    visible (newVal) {
      if (newVal) {
        this.resetForm()
      }
    },
    responseEmail (newVal) {
      if (newVal !== false && newVal !== null) {
        this.progress = false
        this.msgResponseEmail = newVal
        this.$store.dispatch('invoice/setResponseEmail', false)
      }
    },
  },
  methods: {
    resetForm () {
      this.emailsAdicionales = []
      this.msgResponseEmail = ''
      this.progress = false
      this.$store.dispatch('invoice/setResponseEmail', false)
    },
    handleClose () {
      this.resetForm()
      this.$emit('close')
    },
    async sendEmail () {
      this.msgResponseEmail = ''
      this.progress = true
      await this.$store.dispatch('invoice/sendEmail', {
        IdCompania: this.invoiceItem.company_id,
        Prefijo: this.invoiceItem.prefix,
        Consecutivo: this.invoiceItem.consecutive,
        emailsAdicionales: this.emailsAdicionales,
      })
    },
  },
}
</script>